export enum EducationLevelEnum {
  ELEMENTARY = 'ELEMENTARY',
  SECONDARY = 'SECONDARY',
  BACHELOR = 'BACHELOR',
  MASTER = 'MASTER',
  DOCTORAL = 'DOCTORAL',
}
